export default {
    events_main_title: "Events",
    events_main_id: "Id",
    events_main_name: "Name",
    events_main_add_event: "Add Event",
    events_main_firmware: "Firmware",
    events_main_events: "Manufacturer",
    events_main_configuration: "Default Config",
    events_main_canned_commands: "Canned Commands",
    events_main_status: "Status",
    events_main_created_on: "Created On",
    events_main_sync_ctc_information: "Sync CTC Information",
    events_main_diagnostic: "Diagnostic",
    events_main_created_by:"Created By",
    events_main_updated_by:"Updated By",
    events_main_updated_on:"Updated on",

}